import apiClient from './apiClient';
import { Pharmacy, CreatePharmacyRequest, UpdatePharmacyRequest } from '../types/Pharmacy';

export const pharmacyService = {
  getAllPharmacyItems: async (): Promise<Pharmacy[]> => {
    const response = await apiClient.get('/pharmacy');
    return response.data;
  },

  getPharmacyItem: async (id: number): Promise<Pharmacy> => {
    const response = await apiClient.get(`/pharmacy/${id}`);
    return response.data;
  },

  searchPharmacyItems: async (name: string): Promise<Pharmacy[]> => {
    const response = await apiClient.get(`/pharmacy/search?name=${encodeURIComponent(name)}`);
    return response.data;
  },

  getPharmacyItemsByCategory: async (category: string): Promise<Pharmacy[]> => {
    const response = await apiClient.get(`/pharmacy/category/${encodeURIComponent(category)}`);
    return response.data;
  },

  getLowStockItems: async (threshold: number = 10): Promise<Pharmacy[]> => {
    const response = await apiClient.get(`/pharmacy/low-stock?threshold=${threshold}`);
    return response.data;
  },

  getExpiringItems: async (days: number = 30): Promise<Pharmacy[]> => {
    const response = await apiClient.get(`/pharmacy/expiring?days=${days}`);
    return response.data;
  },

  createPharmacyItem: async (pharmacyItem: CreatePharmacyRequest): Promise<Pharmacy> => {
    // Convert empty expiryDate to null for the API
    const payload = {
      ...pharmacyItem,
      expiryDate: pharmacyItem.expiryDate || null
    };
    const response = await apiClient.post('/pharmacy', payload);
    return response.data;
  },

  updatePharmacyItem: async (id: number, pharmacyItem: UpdatePharmacyRequest): Promise<Pharmacy> => {
    // Convert empty expiryDate to null for the API
    const payload = {
      ...pharmacyItem,
      expiryDate: pharmacyItem.expiryDate || null
    };
    const response = await apiClient.put(`/pharmacy/${id}`, payload);
    return response.data;
  },

  updateStock: async (id: number, newQuantity: number): Promise<void> => {
    await apiClient.patch(`/pharmacy/${id}/stock`, newQuantity, {
      headers: { 'Content-Type': 'application/json' }
    });
  },

  deletePharmacyItem: async (id: number): Promise<void> => {
    await apiClient.delete(`/pharmacy/${id}`);
  }
};